module.exports = __webpack_public_path__ + "static/media/cancel-filter-icon.7dbf08a2.svg";